export default __webpack_public_path__ + "static/fmcg-image-strip-3b2231f2547464777f06f239e2b456c7.gif";